import { send } from '../../../../../../src/network/network';
import { type Quiz } from '../../../../../../src/types/Quiz';

type Params = {
  quiz: Quiz;
};

export async function postApiV2CustomersCustomerIdQuizzes({ quiz }: Params) {
  return await send<Quiz>({
    path: `/api/v2/customers/self/quizzes/`,
    method: 'POST',
    body: quiz,
  });
}
